









































































import VueBase from '@/pages/vue-base'
import {Component, Prop} from 'vue-property-decorator'
import axios from 'axios'
import Job, {IJob} from '@/models/Job'
import {apiV1AdminJobsPath} from '@/rails/routes'
import Recruit from '@/models/Recruit'

@Component
export default class RecommendJobList extends VueBase {
  @Prop(Array) readonly recruits!: Array<Recruit>
  jobs: Job[][] = []

  mounted(): void {
    this.reload()
  }

  async reload(): Promise<void> {
    for (const recruit of this.recruits) {
      const params = {
        id: recruit.id
      }
      const jobs = await axios.get<Array<IJob>>(apiV1AdminJobsPath(params))
      this.jobs.push(jobs.data.map(j => new Job(j)))
    }
  }
}
